export const Footer = () => (
  <footer data-testid="site-footer" className="relative overflow-hidden border-t border-white/10 py-14">
    <div className="pointer-events-none absolute -bottom-32 left-1/2 h-64 w-[42rem] -translate-x-1/2 rounded-full bg-fira-pink/25 blur-3xl" />
    <div className="relative z-10 mx-auto flex max-w-4xl flex-col items-center gap-4 px-5 text-center">
      <img src="/fira-logo.png" alt="Fira Worldwide" className="h-7 w-auto invert opacity-70" />
      <p data-testid="footer-tagline" className="font-display text-lg italic text-fira-rose">
        FIRA WORLDWIDE: THE NEW ERA
      </p>
      <p className="text-sm text-white/60">Celebrating Our Journey. Building Our Future.</p>
      <p className="text-xs text-white/40" data-testid="footer-disclaimer">
        Tiada bayaran tiket. Deposit dibuat ke akaun trading broker anda untuk pengesahan seat.
      </p>
      <p className="text-xs text-white/30">© 2026 Fira Worldwide. All rights reserved.</p>
    </div>
  </footer>
);
